import type { CInteractiveMapTranslations } from "./pl";

export const en: CInteractiveMapTranslations = {
  search: "Search",
  empty: "No data to display.",
  emptyMap: "The map has not been configured yet.",
  noResults: "No search results.",
};
